import Darkmode from 'darkmode-js';
import I18n from '../../i18n-js/index.js.erb';
import applyFroalaThemeContent from './froala_theme_content';

const { lang } = document.documentElement;
const tooltip = I18n.t('js.dark_mode.tooltip', { locale: lang });

const opts = {
  time: '0.1s',
  saveInCookies: true,
  left: '10px',
  right: 'unset',
  buttonColorDark: '#FFFFFF',
  buttonColorLight: '#2D333D',
  label: `<div class="button__holder has-full-width tooltip tooltip--right" data-tooltip="${tooltip}"><svg class="icon icon--small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 19c-17.1 0-31 13.9-31 31s13.9 31 31 31 31-13.9 31-31-13.9-31-31-31zm0 55.5v-49c13.5 0 24.5 10.9 24.5 24.5S63.5 74.5 50 74.5z"/></svg></div>`
};

const DarkMode = {
  start() {
    new Darkmode(opts).showWidget();
    this.watchDarkmodeToggle();
  },

  watchDarkmodeToggle() {
    $('.darkmode-toggle').click(() => {
      this.updateIframeDarkmode();
    });
  },

  updateIframeDarkmode() {
    const { darkmode } = window.localStorage;
    const isDark = darkmode === 'true';
    const $iframeBody = $('iframe.fr-iframe').contents().find('body');
    if (isDark) {
      $iframeBody.children().css('color', 'white');
    } else {
      $iframeBody.children().css('color', 'black');
    }
    // The inline pass above only reaches the body's DIRECT children, so nested
    // blocks keep their own inline black/white and render unreadably in one
    // theme or the other -- the Pages workspace and Summary both show this with
    // real content. The shared stylesheet resolves theme-default colours at any
    // depth without editing the content Froala would serialise. The inline pass
    // is left in place so save/editing semantics are unchanged.
    $('iframe.fr-iframe').each((_i, frame) => {
      applyFroalaThemeContent(frame.contentDocument, isDark);
    });
  }
};

export default DarkMode;
